import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import images, { getCardTypes } from '../../../../../../shared/imgs/ccImgs/imgMap';

export const IMAGE_VALUES = Object.keys(images)
  .map((key, idx) => ({
    [key]: (
      <React.Fragment>
        {
          [].concat(images[key]).map((src, i) => (
            <img key={`${idx}${i}`} src={src} alt={key} className="payment-account-creditCard-art"/>
          ))
        }
      </React.Fragment>
    ),
  }))
  .reduce((acc, i) => ({ ...acc, ...i }), {});

const CreditCardInfoField = ({
  className, lastFourDigits, cardType,
}) => {
  const classes = classnames({
    'credit-card-info': true,
  }, className);
  const currentCardType = getCardTypes(cardType);
  return <div className={classes}>
    <span className='card-info-art'>{IMAGE_VALUES[currentCardType]}</span>
    <span className='card-info-digits'>
      <span className='card-info-star'>****</span>
      {lastFourDigits}
    </span>
  </div>;
};

CreditCardInfoField.propType = {
  cardType: string,
  lastFourDigits: string,
};
CreditCardInfoField.defaultProps = {
  lastFourDigits: undefined,
  cardType: 'DEFAULT',
};

export default CreditCardInfoField;
